export default function createImageName(name, type = "jpg") {
  if (!name) return `default_image.${type}`; 
  const sanitized = name.replace(/[^a-zA-Z0-9 ]/g, "").split(" ").join("_");
  return `${sanitized}.${type}`;
}
